import { withPublicHOC } from '../../hoc';

const PrivacyPolicy = () => {
  return <h1>PrivacyPolicy</h1>;
};

export default withPublicHOC(PrivacyPolicy);
